export function Roda3D({
  lado,
  z,
  raio = 0.52,
  largura = 0.5,
  raiada = false,
}: {
  lado: number
  z: number
  raio?: number
  largura?: number
  raiada?: boolean
}) {
  const sinal = Math.sign(lado) || 1
  return (
    <group position={[lado, raio, z]}>
      <mesh rotation={[0, 0, Math.PI / 2]} castShadow>
        <cylinderGeometry args={[raio, raio, largura, 20]} />
        <meshStandardMaterial color="#20252a" roughness={0.93} />
      </mesh>
      <mesh
        position={[sinal * largura * 0.44, 0, 0]}
        rotation={[0, Math.PI / 2, 0]}
      >
        <torusGeometry args={[raio * 0.8, raio * 0.18, 6, 20]} />
        <meshStandardMaterial color="#292e33" roughness={0.88} />
      </mesh>
      <mesh
        position={[sinal * largura * 0.52, 0, 0]}
        rotation={[0, 0, Math.PI / 2]}
      >
        <cylinderGeometry args={[raio * 0.61, raio * 0.61, 0.025, 16]} />
        <meshStandardMaterial
          color="#a8b5c0"
          metalness={0.8}
          roughness={0.26}
        />
      </mesh>
      <mesh
        position={[sinal * largura * 0.55, 0, 0]}
        rotation={[0, 0, Math.PI / 2]}
      >
        <cylinderGeometry args={[raio * 0.44, raio * 0.48, 0.025, 16]} />
        <meshStandardMaterial
          color="#596874"
          metalness={0.7}
          roughness={0.38}
        />
      </mesh>
      {raiada &&
        Array.from({ length: 5 }, (_, i) => {
          const a = (i * Math.PI * 2) / 5
          return (
            <mesh
              key={i}
              position={[
                sinal * (largura * 0.56 + 0.02),
                Math.cos(a) * raio * 0.3,
                Math.sin(a) * raio * 0.3,
              ]}
              rotation={[a, 0, 0]}
            >
              <boxGeometry args={[0.025, raio * 0.49, raio * 0.11]} />
              <meshStandardMaterial
                color="#d7dfe3"
                metalness={0.8}
                roughness={0.25}
              />
            </mesh>
          )
        })}
      <mesh
        position={[sinal * largura * 0.62, 0, 0]}
        rotation={[0, 0, Math.PI / 2]}
      >
        <cylinderGeometry args={[raio * 0.22, raio * 0.22, 0.04, 12]} />
        <meshStandardMaterial
          color="#bdc6cc"
          metalness={0.75}
          roughness={0.25}
        />
      </mesh>
      {Array.from({ length: raiada ? 5 : 6 }, (_, i) => {
        const a = (i * Math.PI * 2) / (raiada ? 5 : 6)
        return (
          <mesh
            key={i}
            position={[
              sinal * (largura * 0.63 + 0.01),
              Math.cos(a) * raio * 0.335,
              Math.sin(a) * raio * 0.335,
            ]}
            rotation={[0, 0, Math.PI / 2]}
          >
            <cylinderGeometry args={[raio * 0.045, raio * 0.045, 0.02, 6]} />
            <meshStandardMaterial
              color="#d2d9dc"
              metalness={0.75}
              roughness={0.3}
            />
          </mesh>
        )
      })}
      {[-0.2, 0.2].map((x) => (
        <mesh
          key={x}
          position={[x * largura, 0, 0]}
          rotation={[0, Math.PI / 2, 0]}
        >
          <torusGeometry args={[raio - 0.007, 0.006, 4, 20]} />
          <meshStandardMaterial color="#12181d" roughness={1} />
        </mesh>
      ))}
    </group>
  )
}
